import React from 'react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';

const AboutPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F9FBF5] pt-20">
      <div className="max-w-5xl mx-auto px-6 py-16">
        {/* Hero */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Connecting Top AI Talent
            <br />
            with Leading Companies
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Duty AI is revolutionizing the way companies find and hire exceptional AI professionals.
            Our platform uses advanced matching algorithms to connect the right talent with the right opportunities.
          </p>
        </div>

        {/* Mission */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Mission</h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            We believe that the future of work is being shaped by artificial intelligence, and finding the right talent
            to build this future shouldn't be difficult. Duty AI was founded to bridge the gap between exceptional
            AI professionals and companies working on cutting-edge projects.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            Our mission is to democratize access to top-tier AI talent while providing professionals with opportunities
            that match their skills, interests, and career goals.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-gray-50 rounded-xl p-8 text-center">
            <div className="text-4xl font-bold text-[#0A3900] mb-2">78.5k+</div>
            <div className="text-gray-600">Roles Created</div>
          </div>
          <div className="bg-gray-50 rounded-xl p-8 text-center">
            <div className="text-4xl font-bold text-[#0A3900] mb-2">$78/hr</div>
            <div className="text-gray-600">Average Pay</div>
          </div>
          <div className="bg-gray-50 rounded-xl p-8 text-center">
            <div className="text-4xl font-bold text-[#0A3900] mb-2">$1.5M+</div>
            <div className="text-gray-600">Daily Payouts</div>
          </div>
        </div>

        {/* Values */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Our Values</h2>
          <div className="grid gap-8">
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Quality First</h3>
              <p className="text-gray-700">
                We maintain the highest standards in our vetting process to ensure both companies and candidates
                get the best matches possible.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Transparency</h3>
              <p className="text-gray-700">
                Clear communication, fair pricing, and honest feedback are at the core of everything we do.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Innovation</h3>
              <p className="text-gray-700">
                We continuously improve our platform using the latest AI and machine learning technologies
                to provide better matches and experiences.
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="bg-[#082900] rounded-2xl p-12 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">Ready to Get Started?</h2>
          <p className="text-lg mb-8 opacity-90">
            Join thousands of AI professionals and companies already using Duty AI.
          </p>
          <div className="flex items-center justify-center gap-4">
            <Button
              size="lg"
              variant="secondary"
              onClick={() => navigate('/jobs')}
            >
              Find Jobs
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="bg-white text-[#0A3900] hover:bg-gray-100"
            >
              Post a Job
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
